import PropTypes from 'prop-types';
import { useState } from 'react';
import Button from '../ui/Button/Button';
import Drawer from '../ui/Drawer/Drawer';
import { Modal } from '../ui/Modal/Modal';
import PriceValidityStyles from './PriceValidity.style';

const PriceValidity = ({ prices, deviceType, textDictionary }) => {
  const [showModal, setShowModal] = useState(false);

  const pricesWithValidity = prices.filter((item) => item.validity);
  if (pricesWithValidity.length === 0) {
    return null;
  }

  const {
    ACCEPT_MKP = 'Aceptar',
    OFFER_VALIDITY = ' Revisar vigencia de la oferta',
    OFFER_VALIDITY_MODAL = 'Vigencia de la oferta',
  } = textDictionary || {};

  const getTypeLabel = (type, validity) => {
    switch (type) {
      case 'cmrPrice':
        return (
          <p>
            Vigencia precio <b>Oportunidad única</b>: hasta el {validity}
          </p>
        );
      case 'internetPrice':
      case 'eventPrice':
        return <p>Vigencia precio con cualquier medio de pago: hasta el {validity}</p>;
      default:
        return validity;
    }
  };

  const getContent = () => (
    <div className={`validity-modal-content ${deviceType === 'mobile' ? 'mobile' : ''}`}>
      <div className="modal-title">{OFFER_VALIDITY_MODAL}</div>
      <ul className="validity-list">
        {pricesWithValidity.map((item) => (
          <div className="price-validity">
            <div className={`icon-${item.type}`} />
            <span>{getTypeLabel(item.type, item.validity)}</span>
          </div>
        ))}
      </ul>
      <div className="accept-button">
        <Button type="mkp-secondary" onClick={() => setShowModal(false)}>
          {ACCEPT_MKP}
        </Button>
      </div>
      <style jsx>{PriceValidityStyles}</style>
    </div>
  );

  return (
    <div className="price-validity-wrapper">
      <button className="open-validity-modal" type="submit" onClick={() => setShowModal(true)}>
        {OFFER_VALIDITY}
      </button>
      {deviceType === 'desktop' ? (
        <Modal
          content={getContent}
          options={{
            disableOutsideClick: true,
            padding: '24px',
            overflow: 'hidden',
            width: 408,
            height: 'fit-content',
            borderRadius: '12px',
          }}
          withPadding={false}
          toggleState={{
            visible: showModal,
            setVisible: setShowModal,
          }}
        />
      ) : (
        <Drawer toggleState={[showModal, setShowModal]} isLoading={false} type="secondary" height="300px">
          {getContent()}
        </Drawer>
      )}

      <style jsx>{PriceValidityStyles}</style>
    </div>
  );
};

PriceValidity.defaultProps = {
  prices: [],
  deviceType: 'desktop',
  textDictionary: {},
};

PriceValidity.propTypes = {
  prices: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      price: PropTypes.number,
      validity: PropTypes.string,
      endDate: PropTypes.string,
    })
  ),
  deviceType: PropTypes.oneOf(['mobile', 'desktop']),
  textDictionary: PropTypes.shape({
    ACCEPT_MKP: PropTypes.string,
    OFFER_VALIDITY: PropTypes.string,
    OFFER_VALIDITY_MODAL: PropTypes.string,
    VALIDITY_ELEMENT_CMR: PropTypes.string,
    VALIDITY_ELEMENT_INTERNET: PropTypes.string,
  }),
};

export default PriceValidity;
